import React from 'react'
import { SponsorshipImage, SponsorshipWrapper } from './Sponsorship.styled'

export interface PlayerSponsorshipProps {
    className?: string
}

function sponsor() {
    return [require('./assets/walga-twl-logo.png'), 'WALGA']
}

export const PlayerSponsorship: React.FC<PlayerSponsorshipProps> = (props) => {
    const [sponsorLogo, sponsorName] = sponsor()
    return (
        <SponsorshipWrapper className={props.className}>
            <SponsorshipImage src={sponsorLogo} alt={sponsorName} />
        </SponsorshipWrapper>
    )
}
